import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        expandCollapse: {
            // "calculator": {state}
            "one": {
                active: false,
                value: null
            },
            "two": {
                active: false,
                value: null
            },
            "three": {
                active: false,
                value: null
            }
        },
        namedExpenses: {
            computerEquipment: null,
            indemnityInsurance: null,
            ir35Insurance: null,
            publicLiability: null,
            accountingFees: null
        },
        otherExpenses: [],
        prepopulate: {
            // prepopulation values for calc two and three
            "two": null,
            "three": null
        },
        googleId: null,
        calcTwoRevert: false,
        calcThreeRevert: false
    },
    mutations: {
        expandCollapseAll(state, payload) {
            // payload = {calculator, action}
            // calculator = "one", "two", "three" etc
            // action = "expand", "collapse" or "reset"
            let actionMap = {
                "expand": {
                    active: true,
                    value: true
                },
                "collapse": {
                    active: true,
                    value: false
                },
                "reset": {
                    active: false,
                    value: null
                }
            };
            let value = actionMap[payload.action];
            state.expandCollapse[payload.calculator] = value;
        },
        updateStoreValue(state, payload) {
            // adhoc store value replace
            state[payload.key] = payload.value;
        },
        prepopulateField(state, payload) {
            // payload = calculator, value
            state.prepopulate[payload.calculator] = payload.value;
        }
    }
})
